import { useQuery } from "@tanstack/react-query"
import { getEducationalVideo } from "../api/educationalVideos"

export const useEducationalVideo = (uuid) =>
  useQuery({
    queryKey: ["educational-video", uuid],
    queryFn: () => getEducationalVideo(uuid),
    retry: false,
    enabled: !!uuid,
    select: (data) => ({
      ...data?.data,
      videos: data?.data?.videos || [],
    }),
  })
